export class CreatePlanogramRequest{
    storeId : string = '';
    merchId : number = -1;
    dataloadId : string = '';
    folderId : string | null = null;
    constructor(storeId: string, merchId: number, dataloadId : string, folderId : string | null){
        this.storeId = storeId;
        this.merchId = merchId;
        this.dataloadId = dataloadId;
        this.folderId = folderId;
    }
}
